import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  CommonOthers,
  CommonParams,
  ErrorMessage,
  GetCommonData,
  Params,
  PostRequest,
} from "../../../../types";
import { GetRoleDataParams, RoleData } from "../../../../types/csoManager/role";
import { handleApiError } from "../../../../utils/errorHandler";

// create
export const createRoleAsync = createAsyncThunk<
  null,
  PostRequest<RoleData, CommonOthers>
>(
  "admin/createRole",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createRole, data);

      reRender(true);
      toast("success", "Role create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Role create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllRoleListAsync = createAsyncThunk<
  GetCommonData<RoleData>,
  Params<GetRoleDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllRoleList", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as CommonParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllRoleList, {
      params: { ...rest },
      headers: {},
    });

    return {
      data: data.data?.getData,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get Role fail");
    return rejectWithValue(error);
  }
});
